import React from "react";
import { BigLinkPanel, IBigLinkPanelProps } from "../../../components/panels/BigLinkPanel";

export type GetBigLinkPanelProps = IBigLinkPanelProps & { id: string };

export const getBigLinkPanel = ({
  id,
  title,
  bgColour,
  content,
  callToActions,
  headingType,
  headerAnchor,
}: IBigLinkPanelProps & { id: string }) => (
  <BigLinkPanel
    key={id}
    title={title}
    headerAnchor={headerAnchor}
    headingType={headingType}
    bgColour={bgColour}
    content={content}
    callToActions={callToActions}
  />
);
